<atx-modal-header
  (dismiss)="close()"
  [showCloseBtn]="true"
  i18n="
    BasketUpload|Basket upload modal header text@@basketUploadModalHeaderText"
>
  Spreadsheet Order Upload
</atx-modal-header>

<atx-modal-body>
  @if (false) {
  <h6
    i18n="
      BasketUpload|Basket upload modal second header
      text@@basketUploadModalSecondHeaderText"
  >
    Copy/Paste your numbers and quantities
  </h6>
  }

  <form [formGroup]="uploadForm">
    @if (!basketUploadRegardlessPreset()) {
    <div
      data-e2e="spreadsheet-order-upload-menu"
      class="d-flex justify-content-center form-group"
    >
      @for (option of uploadBasketOptions$ | async; track option; let last =
      $last) {
      <div class="custom-radio" [class.mr-5]="!last">
        <input
          type="radio"
          class="custom-control-input"
          [attr.data-e2e]="option.e2e"
          [id]="'option-' + option.value"
          [value]="option.value"
          formControlName="uploadOption"
        />
        <label [for]="'option-' + option.value" class="custom-control-label">{{
          option.displayValue | uppercase
        }}</label>
      </div>
      }
    </div>
    }

    <div class="form-group">
      <textarea
        class="form-control"
        [formControl]="productsControl"
        data-e2e="cbasket-upload-products-textarea"
        rows="10"
        i18n-placeholder="
          basketUpload|Placeholder for basket upload ean/quantity
          field@@basketUploadEanQuantityPlaceholder"
        placeholder="Insert EAN and quantity here"
      ></textarea>
    </div>
    @if ((submitted$ | async) && productsControl.invalid) {
    <div class="text-danger">
      @if (productsControl.errors?.required) {
      <span
        data-e2e="cbasket-upload-empty-products-error"
        i18n="
          basketUpload|Basket upload required error
          message@@basketUploadModalEmptyProductsErrorMessage"
        >EAN and quantity is empty</span
      >
      } @if (productsControl.errors?.requiredQuantity) {
      <span
        data-e2e="cbasket-upload-empty-quantity-error"
        i18n="
          basketUpload|Basket upload empty quantity error
          message@@basketUploadModalEmptyQuantityProductsErrorMessage"
        >Invalid paste. Empty quantity for
        {{ productsControl.errors?.requiredQuantity }}</span
      >
      } @if (productsControl.errors?.maxSKULimit) {
      <span
        data-e2e="cbasket-upload-max-sku-error"
        i18n="
          basketUpload|Basket upload sku limit
          message@@basketUploadModalSkuLimitErrorMessage"
        >Invalid paste. Max SKU limit is exceeded. SKU's:
        {{ productsControl.errors?.maxSKULimit }}. Limit :
        {{ skuLimit$ | async }}</span
      >
      }
    </div>
    }
  </form>
</atx-modal-body>

<atx-modal-footer>
  @for (uploadBtn of basketUploadButtons; track uploadBtn.btnText) {
  <button
    class="btn btn-primary"
    data-e2e="cbasket-upload-sdo-basket-btn"
    (click)="confirmUpload(uploadBtn.addToExistingBasket)"
    [disabled]="isUploading() || ((submitted$ | async) && uploadForm.invalid)"
  >
    @if (isUploading() && addToExistingBasketUploadMode() ===
    uploadBtn.addToExistingBasket) {
    <fa-icon
      [icon]="['fas', 'spinner']"
      animation="spin-pulse"
      class="mr-1"
    ></fa-icon>
    }
    {{ uploadBtn.btnText }}
  </button>
  }
</atx-modal-footer>
